import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const PinLocationIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="13"
      height="14"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33422 2.96676C4.57616 1.74967 6.24823 1.07187 7.98708 1.08065C9.72594 1.08943 11.3911 1.78409 12.6207 3.01366C13.8502 4.24324 14.5449 5.90837 14.5537 7.64723C14.5624 9.38609 13.8846 11.0582 12.6676 12.3001L9.17922 15.7884C8.86668 16.1009 8.44283 16.2764 8.00089 16.2764C7.55895 16.2764 7.1351 16.1009 6.82256 15.7884L3.33422 12.3001C2.09663 11.0624 1.40137 9.38374 1.40137 7.63343C1.40137 5.88311 2.09663 4.20448 3.33422 2.96676Z"
        stroke="#292D32"
        strokeWidth="1.25"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8 10.1334C9.38071 10.1334 10.5 9.01413 10.5 7.63342C10.5 6.25271 9.38071 5.13342 8 5.13342C6.61929 5.13342 5.5 6.25271 5.5 7.63342C5.5 9.01413 6.61929 10.1334 8 10.1334Z"
        stroke="#292D32"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}
